const input = require('../input/input');

// Date / datetime component. Library-agnostic: it renders a native input and
// delegates the actual picker to the theme's `datepicker` behaviour. base ships
// a native HTML5 adapter (zero-dep default); metronic_8 overrides it with
// tempusDominus while keeping localized display. Either way the value submitted
// is the ISO string the handle's getValue() returns.
const date = Object.assign({}, input, {
    subelements: {
        validationMessage: null
    },
    // The native picker (and tempusDominus) emit `change`, not `keyup`.
    validationTriggeringEvents: ['change'],

    // These mirror data-zit-* attributes on the input and are auto-read by
    // readZAttributes(); they are forwarded to the datepicker behaviour so a
    // richer picker can honour them (the native input ignores most of them).
    minDate: false,
    maxDate: false,
    startOfTheWeek: 1,
    format: 'yyyy-MM-dd',
    locale: 'en',
    time: false,
    disabledDaysOfTheWeek: [],

    // Handle returned by hm.behaviors.datepicker.create() — owns getValue/setMin/setMax.
    datepickerHandle: false,

    init: function () {
        input.init.call(this);

        // A read-only field renders a static display + hidden input (no editable control),
        // so there is no picker to attach — leaving the handle false makes getValue read the
        // hidden input's stored ISO value directly.
        if (this.readOnly) {
            return;
        }

        // Hand the element to the theme's datepicker behaviour. The handle is the
        // single source of truth for the field's value (see getValue below).
        this.datepickerHandle = this.hm.behaviors.datepicker.create(this.element, {
            time: this.time,
            minDate: this.minDate === false ? false : this.minDate,
            maxDate: this.maxDate === false ? false : this.maxDate,
            format: this.format,
            locale: this.locale,
            startOfTheWeek: this.startOfTheWeek,
            disabledDaysOfTheWeek: this.disabledDaysOfTheWeek
        });
    },

    // Submit/validation read the value through the picker handle, so a theme that
    // displays a localized string (metronic_8) still returns ISO to the server.
    getValue: function () {
        if (this.datepickerHandle !== false) {
            return this.datepickerHandle.getValue();
        }
        return this.element.value;
    }
});

module.exports = date;
